export class DataTableConfig {
	filterDebounceTime: number = 300;
}
